export const groupBy = <T, K extends string | number | symbol>(
  items: T[],
  by: (i: T) => K | null | undefined,
): Record<K, T[]> =>
  items.reduce((groups, item) => {
    const value = by(item);
    if (value !== null && value !== undefined) {
      (groups[value] ||= []).push(item);
    }
    return groups;
  }, {} as Record<K, T[]>);
